import React, { Component } from 'react';
import Popover from '../common/popover';

import './styles.css';

export default class PhotoPreview extends Component{

  constructor(props){
    super(props)
    this.state = {
      isOpenTagList: false,
      openTagListObj: {},
    }
  }

  // static getDerivedStateFromProps(nextProps, prevState) {
  //   return null;
  // }

  onClickSelectTag = (nameHashCode) => {
    this.setState(prevState => ({
      openTagListObj: {
        ...prevState.openTagListObj,
        [nameHashCode]: !prevState.openTagListObj[nameHashCode]
      }
    }))
  }

  onClickDone = (nameHashCode) => {
    this.setState(prevState => ({
      openTagListObj: {
        ...prevState.openTagListObj,
        [nameHashCode]: false
      }
    }))
  }

  popoverContent = (nameHashCode) => {
    if(!this.props.metaDetails.tags) return <p>No tags found.</p>;
    let tagData = this.props.fileUrls[nameHashCode].tagsArray || [];
    let uiElements = Object.entries(this.props.metaDetails.tags).map(([key, name], i) => (
      <span
        key={i}
        className={`photoTag cursor${tagData.includes(+key)? ' selectedTag': ''}`}
        onClick={() => this.onTagSelection(key, nameHashCode)}
      >
        {name}
      </span>
    ));

    return (
      <div className='photoTagWrp'>
        <div className='photoTagContent'>
          {uiElements}
        </div>
        <div className='width100 marginTop15'>
          <span className='multiTagTxt'>Multiple tags can be selected.</span>
          <p className='tagDoneTxt cursor' onClick={() => this.onClickDone(nameHashCode)}>Done</p>
        </div>
      </div>
    );
  }

  onTagSelection(tagKey, nameHashCode) {
    this.props.onTagSelection(tagKey, nameHashCode);
  }

  render() {
    const { fileUrls, deletePhoto } = this.props;
    return (
      <React.Fragment>
        {
          Object.keys(fileUrls).map((nameHashCode, i) => {
            const fileInfo = fileUrls[nameHashCode] || {};
            if(fileInfo && fileInfo.loaded) {
              return (
                <div key={i} className='grid-item photoGap'>
                  <div key={i} className='preview'>
                    <img alt="BUS" className='busImage' src={fileInfo.data} />
                    <div onClick={() => deletePhoto(nameHashCode)} className="crossIcon cursor">X</div>
                  </div>
                  <div className='tagsWrapper'>
                    <label className='busPhotoTagsLabel cursor' onClick={() => this.onClickSelectTag(nameHashCode)}>
                      {fileInfo.tagsArray && fileInfo.tagsArray.length && !this.state.openTagListObj[nameHashCode]? 
                        `${fileInfo.tagsArray.length} ${fileInfo.tagsArray.length > 1? 'tags': 'tag'} selected`
                        : 'Select Tags'
                      }
                      <span style={{'color': '#3d474c'}}> &#9662;</span>
                    </label>
                    <Popover
                      data={nameHashCode}
                      isOpen={this.state.openTagListObj[nameHashCode]}
                      popoverContent={this.popoverContent}
                    />
                  </div>
                </div>
              )
            }
            return null;
          })
        }
      </React.Fragment>
    )
  }
}
